import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
// tslint:disable-next-line: no-absolute-import

@Injectable({ providedIn: 'root' })
export class BaseUrlService {
  private apiBaseURL: string;
  private identityBaseURL: string;
  private homeBaseURL!: string;
  private propertySourceId: string;
  constructor() {
    this.identityBaseURL = environment.identityUrl;
    this.apiBaseURL = environment.spaceApiUrl;
    this.propertySourceId = environment.propertySourceId;
  }

  public getApiBaseURL(): string {
    return this.apiBaseURL;
  }

  public getIdentityBaseURL(): string {
    return this.identityBaseURL;
  }

  public getHomeBaseURL(): string {
    return this.homeBaseURL;
  }

  public setHomeBaseUrl(val: string): void {
    this.homeBaseURL = val;
  }

  public getPropertySourceId(): string {
    return this.propertySourceId;
  }
}
